var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.262 29.7582C42.4883 29.6175 45.7998 26.0832 45.6585 21.8642C45.5171 17.6451 41.9764 14.339 37.7501 14.4796C33.5238 14.6203 30.2123 18.1546 30.3536 22.3737C30.495 26.5927 34.0357 29.8989 38.262 29.7582Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.262 87.9691C42.4883 87.8285 45.7998 84.2942 45.6585 80.0751C45.5171 75.8561 41.9764 72.5499 37.7501 72.6906C33.5238 72.8313 30.2123 76.3655 30.3536 80.5846C30.495 84.8036 34.0357 88.1098 38.262 87.9691Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9942 35.9051C25.8832 32.8171 25.7256 27.9764 22.6423 25.0931C19.5591 22.2097 14.7176 22.3756 11.8286 25.4635C8.93964 28.5514 9.09715 33.3921 12.1804 36.2755C15.2637 39.1588 20.1052 38.993 22.9942 35.9051Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1582 77.0769C67.0472 73.989 66.8897 69.1483 63.8064 66.265C60.7231 63.3816 55.8817 63.5474 52.9927 66.6354C50.1037 69.7233 50.2612 74.564 53.3445 77.4473C56.4278 80.3307 61.2693 80.1649 64.1582 77.0769Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5355 50.9684C16.3949 46.7421 12.8606 43.4306 8.64153 43.572C4.42248 43.7134 1.1163 47.2541 1.25699 51.4804C1.39767 55.7067 4.93194 59.0182 9.151 58.8768C13.3701 58.7355 16.6762 55.1948 16.5355 50.9684Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7465 50.9684C74.6058 46.7421 71.0715 43.4306 66.8525 43.572C62.6334 43.7134 59.3272 47.2541 59.4679 51.4804C59.6086 55.7067 63.1429 59.0182 67.3619 58.8768C71.581 58.7355 74.8872 55.1948 74.7465 50.9684Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6355 66.2285C19.5476 63.3395 14.7069 63.497 11.8235 66.5803C8.94019 69.6636 9.10602 74.5051 12.194 77.394C15.2819 80.283 20.1226 80.1255 23.0059 77.0422C25.8893 73.9589 25.7235 69.1175 22.6355 66.2285Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7996 25.0566C60.7117 22.1676 55.871 22.3251 52.9876 25.4084C50.1042 28.4917 50.2701 33.3332 53.358 36.2222C56.446 39.1111 61.2866 38.9536 64.17 35.8703C67.0534 32.7871 66.8875 27.9456 63.7996 25.0566Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0938 42.4784C39.8085 42.4213 41.1521 40.9874 41.0947 39.2756C41.0373 37.5638 39.6008 36.2224 37.886 36.2795C36.1713 36.3365 34.8277 37.7705 34.8851 39.4823C34.9425 41.1941 36.379 42.5355 38.0938 42.4784Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0938 66.1112C39.8085 66.0541 41.1521 64.6202 41.0947 62.9084C41.0373 61.1966 39.6008 59.8552 37.886 59.9123C36.1713 59.9694 34.8277 61.4033 34.8851 63.1151C34.9425 64.8269 36.379 66.1683 38.0938 66.1112Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8713 44.9679C33.0434 43.7151 32.9795 41.7511 31.7285 40.5812C30.4775 39.4114 28.5132 39.4786 27.3411 40.7315C26.169 41.9844 26.2329 43.9484 27.4838 45.1182C28.7348 46.2881 30.6991 46.2208 31.8713 44.9679Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5744 61.6789C49.7465 60.426 49.6826 58.462 48.4316 57.2921C47.1807 56.1223 45.2164 56.1896 44.0442 57.4424C42.8721 58.6953 42.936 60.6593 44.187 61.8292C45.4379 62.999 47.4023 62.9317 48.5744 61.6789Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2792 51.1094C29.2221 49.3946 27.7881 48.0511 26.0764 48.1084C24.3646 48.1658 23.0232 49.6023 23.0802 51.3171C23.1373 53.0318 24.5713 54.3754 26.2831 54.318C27.9948 54.2607 29.3362 52.8241 29.2792 51.1094Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9003 51.1094C52.8432 49.3946 51.4092 48.0511 49.6974 48.1084C47.9857 48.1658 46.6443 49.6023 46.7013 51.3171C46.7584 53.0318 48.1924 54.3754 49.9042 54.318C51.6159 54.2607 52.9573 52.8241 52.9003 51.1094Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3026 51.1094C41.2455 49.3946 39.8116 48.0511 38.0998 48.1084C36.388 48.1658 35.0466 49.6023 35.1037 51.3171C35.1608 53.0318 36.5947 54.3754 38.3065 54.318C40.0183 54.2607 41.3597 52.8241 41.3026 51.1094Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7414 57.3006C30.4885 56.1285 28.5245 56.1924 27.3546 57.4434C26.1848 58.6943 26.2521 60.6586 27.5049 61.8308C28.7578 63.0029 30.7218 62.939 31.8917 61.688C33.0615 60.4371 32.9942 58.4727 31.7414 57.3006Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4523 40.6053C47.1994 39.4332 45.2354 39.4971 44.0656 40.748C42.8957 41.999 42.963 43.9633 44.2159 45.1355C45.4687 46.3076 47.4327 46.2437 48.6026 44.9927C49.7724 43.7418 49.7052 41.7774 48.4523 40.6053Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.e73aefea1f55475942b198746a570234.svg";
export { ForwardRef as ReactComponent };